(function () {

    'use strict';

    angular.module('iplusjs.print', [
        'iplusjs.button.link'
    ])
    .component('iplusjsPrint', {
        templateUrl: 'common/print/print.html',
        bindings: {
            name: '@ipName',
            cssClass: '@ipCssClass'
        },
        transclude: true,
        controller: PrintController,
        controllerAs: 'printVm'
    });

    PrintController.$inject = [
        '$window'
    ];
    function PrintController($window) {
        var vm = this;

        vm.$onInit = onInit;
        vm.print = print;

        function activate() {}

        function onInit() {
            activate();
        }

        function print() {
            var origTitle = $window.document.title;

            if ($window && angular.isFunction($window.print)) {
                $window.document.title = vm.name ? vm.name : origTitle;
                $window.print();
                $window.document.title = origTitle;
            }
        }
    }

})();
